<template>
    <div id="fastTaskByLaws">
        <Headers :headersText='headersText'></Headers>
        <!-- 步骤流程 -->
        <div class="explain">
            <div class="explainPanel">
                <div class="public">
                    <img src="../assets/images/img_58.png" alt="">
                    <span>下载</span>
                </div>
                <img src="../assets/images/img_55.png" alt="" class="rightArrow">
                <div class="public">
                    <img src="../assets/images/img_57.png" alt="">
                    <span>试玩</span>
                </div>
                <img src="../assets/images/img_55.png" alt="" class="rightArrow">                
                <div class="public">
                    <img src="../assets/images/img_56.png" alt="">
                    <span>领奖</span>
                </div>
            </div>
        </div>
        <!-- 细则面板 -->
        <div class="boxPadding">
            <div class="panel">
                <div>*快速任务</div>
                <div>按照步骤完成快速任务立即获得奖励；</div>
                <div>任务抢完只需耐心等待，系统随时更新海量新任务</div>
                <div class="marginT">*回调任务</div>
                <div>回调任务奖励的到账时间通常是即时到账或者5分钟内到账，极少有但不排除有用户获取奖励失败，如遇到特殊情况请联系客服</div>
                <div class="marginT">*联盟任务</div>
                <div>联盟任务收益自动到账，有时会出现延迟情况请耐心等待</div>
                <div class="marginT">少数任务无法获取收益，原因可能是：</div>
                <div>1.用户非首次安装</div>
                <div>2.用户未按要求完成步骤</div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import Headers from '../components/headersL'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'快速任务细则',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #fastTaskByLaws{
        // 步骤流程
        .explain{
            width: 375px;
            height: 58px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .explainPanel{
                width:245px;
                height:50px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                margin: 0px 15px;
                position: relative;
                top: 8px;
                padding: 25px 50px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .public{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    img{
                        width: 26px;
                        height: 26px;
                    }
                    span{
                        margin-top: 6px;
                        font-size: 15px;
                        color: #151515;
                        font-weight: bold;
                    }
                }
                .rightArrow{
                    width: 30px;
                    height: 17px;
                }
            }
        }
        // 细则面板
        .boxPadding{
            padding-bottom: 15px;
            .panel{
                width:309px;
                // height:288px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                margin: 65px 15px 0;
                padding: 15px 21px 15px 15px;
                font-size:13px;
                color:rgba(17,17,17,1);
                font-weight: 400;
                line-height:18px;
                .marginT{
                    margin-top: 18px;
                }
            }
        }
    }
</style>